import { User } from '../models/user';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class UserService {
    public currentUser: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(
        private router: Router,
        private permissionsService: NgxPermissionsService,
        private restangular : Restangular
    ) {
        // TODO
    }

    public setCurrentUser(user: User) {
        this.currentUser.next(user);
    }

    public logout() {
        let user = new User();
        user.connected = false;
        sessionStorage.removeItem("token");
        this.permissionsService.flushPermissions();
        this.router.navigate(['login']);
    }

    getMenus(): Observable<any> {
        return this.restangular.one('menus').customGET();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/user.service.ts